import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  name: 'DropdownDatepicker',
  props: {
    dateInput: String,
    minYear: {
      type: Number,
      default: 1910
    }
  },
  data() {
    return {
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      dateValue: moment(),
      daysInMonth: [0],
      defaultSelected: {
        year: 1990,
        month: 1,
        day: 1
      },
      defaultDay: 31
    }
  },
  mounted() {
    this.setDate()
    this.daysInMonth = Array.from({ length: this.defaultDay }, (value, index) => 1 + index)
    this.$emit('update', this.dateValue.format('YYYY-MM-DD'))
  },
  created() {
    this.calculateDaysInMonth(this.defaultSelected.year, 0, 1)
  },
  computed: {
    untilCurrentYear() {
      let currentYear = new Date().getFullYear() - 10
      return Array.from({ length: currentYear + 1 - this.minYear }, (value, index) => this.minYear + index)
    }
  },
  methods: {
    editValue(unit: any, event: any) {
      this.dateValue.set(unit, event)
      if (unit === 'months') {
        this.dateValue.set(unit, event - 1)
      }
      this.daysInMonth = Array.from({ length: this.dateValue.daysInMonth() }, (value, index) => 1 + index)
      this.$emit('update', this.dateValue.format('YYYY-MM-DD'))
    },
    calculateDaysInMonth(year: number, month: number, date: number) {
      this.dateValue.set('year', year)
      this.dateValue.set('months', month)
      this.dateValue.set('date', date)
      this.daysInMonth = Array.from({ length: this.dateValue.daysInMonth() }, (value, index) => 1 + index)
    },
    setDate() {
      if (this.dateInput) {
        let splitDate = this.dateInput.split('-')
        this.defaultSelected = {
          year: Number(splitDate[0]),
          month: Number(splitDate[1]),
          day: Number(splitDate[2])
        }
        this.calculateDaysInMonth(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2]))
      }
    }
  }
})
